<template>
    <main-content>
        <div class="bg-white p-3 rounded shadow-sm">
            <!-- Tabs -->
            <div>
                <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item" v-if="!is_direct_settlement">
                        <router-link
                            :class="[
                                'nav-link',
                                tab == 'gateway-form' ? 'active' : ''
                            ]"
                            :to="`/settlement-settings/ipg/${hashid}/gateway-form`"
                            role="tab"
                            :aria-selected="tab == 'gateway-form'"
                        >
                            {{ $t('label.settlement_schedule') }}
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link
                            :class="[
                                'nav-link',
                                tab == 'changes-requests' ? 'active' : ''
                            ]"
                            :to="`/settlement-settings/ipg/${hashid}/changes-requests`"
                            role="tab"
                            :aria-selected="tab == 'changes-requests'"
                        >
                            {{ $t('label.add_sheba_to_gateway') }}
                        </router-link>
                    </li>
                    <li class="nav-item" v-if="show_enamad_tab">
                        <router-link
                            :class="[
                                'nav-link',
                                tab == 'register-enamad' ? 'active' : ''
                            ]"
                            :to="`/settlement-settings/ipg/${hashid}/register-enamad`"
                            role="tab"
                            :aria-selected="tab == 'register-enamad'"
                        >
                            {{ $t('label.enamad_register') }}
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link
                            :class="[
                                'nav-link',
                                $route.name == 'gateways_allotment'
                                    ? 'active'
                                    : ''
                            ]"
                            :to="`/gateways/${hashid}/allotment`"
                            >{{ $t('allotment.settlement_sheba') }}</router-link
                        >
                    </li>
                    <li class="nav-item" v-if="!is_direct_settlement">
                        <router-link
                            :class="[
                                'nav-link',
                                $route.name == 'gateway_stakeholders_list'
                                    ? 'active'
                                    : ''
                            ]"
                            :to="`/gateways/stakeholders/${hashid}`"
                            >{{
                                $t('stakeholders.label.shop_stakeholders_list')
                            }}</router-link
                        >
                    </li>
                    <li class="nav-item" v-if="show_stakeholders_tab">
                        <router-link
                            :class="[
                                'nav-link',
                                $route.name == 'stakeholders_get' &&
                                $route.query.gateway_hashid == hashid
                                    ? 'active'
                                    : ''
                            ]"
                            :to="`/stakeholders?gateway_hashid=${hashid}`"
                            >{{
                                $t('stakeholders.label.manage_stakeholders')
                            }}</router-link
                        >
                    </li>
                </ul>
            </div>

            <!-- Tab Contents -->
            <div class="tab-content">
                <div :class="['tab-pane', tab == 'gateway-form' ? 'active':'']" id="gateway-form" v-if="!is_direct_settlement">
                    <div class="p-4 bg-white rounded shadow-sm mt-5">
                        <div class="mt-2 mb-4 h5">
                            {{ $t('label.settlement_settings') }}
                        </div>
                        <form
                            @submit.prevent="saveSettlementSettings()"
                            id="settlement_form"
                        >
                            <div class="row">
                                <div class="col-12 col-md-12 my-2">
                                    <div class="custom-control custom-switch">
                                        <input
                                            type="checkbox"
                                            class="custom-control-input"
                                            id="skip_settlement"
                                            v-model="settlement.skip_settlement"
                                            :disabled="
                                                settlement.skip_settlement_locked ===
                                                    1 &&
                                                !$can(
                                                    'wallet.manage-upcoming-settlement-settings'
                                                )
                                            "
                                        />
                                        <label
                                            class="custom-control-label"
                                            for="skip_settlement"
                                        >
                                            {{ $t('label.skip_settlement') }}
                                        </label>
                                    </div>
                                </div>

                                <div class="col-12 col-md-6 my-2">
                                    <label for="settlement_period">{{
                                        $t('label.settlement_period')
                                    }}</label>
                                    <select
                                        id="settlement_period"
                                        class="form-control"
                                        v-model="settlement.settlement_period"
                                    >
                                        <option
                                            v-for="(
                                                item, index
                                            ) in settlementPeriod"
                                            :key="index"
                                            v-text="
                                                settlementPeriodStr.get(item)
                                            "
                                            :value="item"
                                        ></option>
                                    </select>
                                </div>

                                <div
                                    class="col-12 col-md-6 my-2"
                                    v-if="
                                        settlement.allotment_type ===
                                        allotmentType.directDebit
                                    "
                                >
                                    <label for="company_id">{{
                                        $t('label.settlement_target')
                                    }}</label>
                                    <select
                                        id="company_id"
                                        class="form-control"
                                        v-model="settlement.company_id"
                                        @change="changeCompanyId"
                                    >
                                        <option
                                            v-for="(
                                                item, index
                                            ) in settlementTarget"
                                            :key="index"
                                            v-text="
                                                settlementTargetStr.get(item)
                                            "
                                            :value="item"
                                        ></option>
                                    </select>
                                </div>
                            </div>

                            <div class="mt-4 d-flex flex-wrap">
                                <button
                                    class="btn btn-success me-3 mt-2"
                                    type="submit"
                                    id="save_settlement_changes"
                                >
                                    {{ $t('btn.save') }}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>

                <!-- Change Requests -->
                <div
                    :class="[
                        'tab-pane',
                        tab == 'changes-requests' ? 'active' : ''
                    ]"
                    id="changes-requests"
                >
                    <change-requests
                        v-if="status == 'setFormData'"
                        :form_data="form_data"
                    ></change-requests>
                </div>

                <!-- Register Enamad -->
                <div
                    :class="[
                        'tab-pane',
                        tab == 'register-enamad' ? 'active' : ''
                    ]"
                    id="register-enamad"
                    v-if="show_enamad_tab"
                >
                    <register-enamad
                        v-if="status == 'setFormData'"
                        :form_data="form_data"
                    ></register-enamad>
                </div>
            </div>
        </div>
    </main-content>
</template>

<script>
import { collectiveService, gatewayService } from '@/common/api.service';
import { mapGetters } from 'vuex';
import mainContent from '@/components/main-content';
import changeRequests from '@/views/gateway/components/change-requests';
import RegisterEnamad from '@/views/gateway/components/register-enamad';
import $ from 'jquery';
import { KTApp } from '@/plugins/core/app';
import toastr from 'toastr';
import {
    settlementPeriod,
    settlementPeriodStr
} from '@/constants/settlementPeriod';
import { allotmentType } from '@/constants/allotmentType';
import {
    settlementTarget,
    settlementTargetStr
} from '@/constants/settlementTarget';
import { shopType } from '@/constants/ShopType';

export default {
    components: { mainContent, changeRequests, RegisterEnamad },
    computed: {
        ...mapGetters('gateway', ['form_data', 'status']),
        tab() {
            const currentTab = this.$route.params.type;
            const allowedTabs = [];
            if (!this.is_direct_settlement) allowedTabs.push('gateway-form');
            allowedTabs.push('changes-requests');
            if (this.show_enamad_tab) allowedTabs.push('register-enamad');

            if (currentTab && allowedTabs.includes(currentTab))
                return currentTab;

            return this.is_direct_settlement
                ? 'changes-requests'
                : 'gateway-form';
        },
        hashid() {
            return this.$route.params.hashid;
        },
        is_direct_settlement() {
            return !!this.form_data && this.form_data.type === shopType.BUSINESS_PSP_SETTLEMENT;
        },
        show_stakeholders_tab() {
            return (
                this.form_data &&
                this.form_data.gateway_type === 0 &&
                this.form_data.type === 2
            );
        },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: 'toast-bottom-center',
                preventDuplicates: true,
                rtl: false
            };
            return toastr;
        }
    },
    data() {
        return {
            show_enamad_tab: false,
            settlement: {
                skip_settlement: false,
                settlement_period: settlementPeriod.EVERY_DAY,
                allotment_type: allotmentType.normal,
                company_id: null,
                wallet_hashid: '',
                skip_settlement_locked: 0
            },
            settlementPeriod,
            settlementPeriodStr,
            allotmentType,
            settlementTarget,
            settlementTargetStr,
            resend_request_btn: false,
            is_starshop:
                this.$route.params.gateway_source === 'starshop-gateways'
        };
    },
    mounted() {
        this.loadGatewayData();
        this.getWalletSettings();
        this.getSettlementSettings();
    },
    methods: {
        loadGatewayData() {
            if (!this.hashid) return;
            this.$store
                .dispatch('gateway/find', this.hashid)
                .then(() => {
                    if (this.form_data.status === 12)
                        this.show_enamad_tab = true;
                })
                .catch(({ response }) => console.error(response));
        },
        getWalletSettings() {
            collectiveService
                .get_wallet_settings({ gateway_hashid: this.hashid })
                .then((res) => {
                    if (res.data.data.wallet_hashid)
                        this.form_data.wallet_hashid =
                            res.data.data.wallet_hashid;
                });
        },
        updateWalletSettings() {
            let form = $('#wallet_settings');
            let btn = $('#submit_btn');

            form.validate({ rules: { wallet_hashid: { required: true } } });
            if (!form.valid()) return;

            KTApp.progress(btn);
            collectiveService
                .update_wallet_settings({
                    gateway_hashid: this.hashid,
                    wallet_hashid: this.form_data.wallet_hashid
                })
                .then(() => this.$router.push('/gateways'))
                .catch(({ response }) => {
                    if (response.data)
                        form.validate().showErrors(response.data.data);
                    this.showMsg(form, 'danger', response.data.message);
                })
                .finally(() => KTApp.unprogress(btn));
        },
        saveSettlementSettings() {
            let form = $('#settlement_form');
            const { skip_settlement_locked, ...params } = this.settlement;
            gatewayService
                .setTerminalSettlementSettings(
                    this.hashid,
                    params,
                    this.is_starshop
                )
                .then((res) => this.showMsg(form, 'success', res.data.message))
                .catch(({ response }) => {
                    if (response.status >= 400 && response.status < 500)
                        this.showMsg(form, 'danger', response.data.message);
                    else this.toastr.error('خطای سرور!');
                })
                .finally(() => this.getSettlementSettings());
        },
        getSettlementSettings() {
            gatewayService
                .getTerminalSettlementSettings(this.hashid, this.is_starshop)
                .then((res) => {
                    Object.assign(this.settlement, res.data.data);
                    this.settlement.skip_settlement_locked = Number(
                        res.data.data.skip_settlement_locked || 0
                    );
                    this.resend_request_btn =
                        res.data.data.allotment_type ===
                        this.allotmentType.allotmentToPf;
                })
                .catch(() => console.error('cant fetch settlement settings'));
        },
        changeCompanyId() {
            if (
                this.settlement.allotment_type !==
                this.allotmentType.directDebit
            )
                this.settlement.company_id = null;
        }
    }
};
</script>

<style scoped>
.dropdown.bootstrap-select.disabled {
    border: 1px solid #e2e5ec;
    border-radius: 4px;
    background-color: #f7f8fa;
    opacity: 1;
    color: #495057;
}
</style>
